interface LogoProps {
  width?: number
  /** "white" for dark backgrounds (top bar), "dark" for light ones. */
  variant?: "white" | "dark"
}

// SourcePilot wordmark (SOURCE ⬡ PILOT). Two pre-rendered PNG variants
// live in /public: -white (for dark chrome) and -dark (for light
// pages). Plain <img> instead of next/image so every consumer shares
// one browser-cached fetch per variant (WorkspaceContent renders the
// dark one via a plain <img> too).
const WORDMARK_ASPECT = 2880 / 487

export function Logo({ width = 140, variant = "white" }: LogoProps) {
  const height = Math.round(width / WORDMARK_ASPECT)

  return (
    <a href="https://sourcepilot.ai" target="_blank" rel="noopener noreferrer" className="flex">
      <img
        src={`/sourcepilot-wordmark-${variant}.png`}
        alt="SourcePilot Logo"
        width={width}
        height={height}
        style={{ width: width, height: height }}
      />
    </a>
  )
}
